module.exports = __webpack_public_path__ + "media/images/cd-badge-359afdf71a5d9de56ec9cdd04f5bc2bb.png";